var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
console.log('Plugin Progressbar started');
import { ProgressbarMetadata } from "./progressbar.metadata";
const CssContent = `
  :host {
    display: block;
    overflow: hidden;
    width: 100%;
    height: 50px;
    padding: 10px 10px;
    box-sizing: border-box;
  }
  
  .content {
    height: 100%; 
    background-color: var(--theme-tertiary-color);
    border-radius: var(--border-radius);
  }

  .progress-bar {	
    height: 100%; 
    width: 100%; 
    background-color: var(--color2);     
    background-image: linear-gradient(
      45deg, var(--color1) 25%, 
      transparent 25%, transparent 50%, 
      var(--color1) 50%, var(--color1) 75%,
      transparent 75%, transparent);

    border-radius: var(--border-radius);
  }
`;
const HtmlContent = `
  <div class="progress-bar"></div>                       
`;
class ProgressBarComponent extends HTMLElement {
    constructor() {
        super();
        this.shadow = this.attachShadow({ mode: 'open' });
        this.htmlElement = document.createElement('div');
        this.htmlElement.className = 'content';
        this.styleElement = document.createElement('style');
    }
    connectedCallback() {
        this.shadow.appendChild(this.styleElement);
        this.shadow.appendChild(this.htmlElement);
        this.styleElement.innerHTML = CssContent;
        this.htmlElement.innerHTML = HtmlContent;
        this.refresh();
    }
    static get observedAttributes() {
        return ['value'];
    }
    attributeChangedCallback() {
        this.refresh();
    }
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            const value = this.getAttribute('value');
            const element = this.shadow.querySelector('.progress-bar');
            if (element && value) {
                element.style.width = value + '%';
            }
        });
    }
}
zySdk.services.registry.registerComponent(ProgressbarMetadata, ProgressBarComponent);
